import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiCardActions = {
  styleOverrides: { root: { gap: '8px', padding: '0 24px 24px' } },
} satisfies Components<Theme>['MuiCardActions'];
